import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { cashierMenu, menu } from "../Navbar";
import { MdArrowDropDown } from "react-icons/md";
import { Sidebar } from "primereact/sidebar";
import SearchField from "../../../components/Shared/SearchField";
export function isActivePath(item, location) {
  if (item?.path && location.pathname.startsWith(item.path)) return true;
  if (item?.children)
    return item.children.some((subItem) =>
      location.pathname.startsWith(subItem.path),
    );
  return false;
}

function SideBar({ setNavMenuOpen, navMenuOpen, childrens, setChildrens }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [navMenuArray, setNavMenuArray] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const [expandedIndices, setExpandedIndices] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar-collapsed") === "true",
  );
  const searchRef = useRef(null);

  useEffect(() => {
    if (user?.role_id === 1 || user?.role_id === 2) {
      setNavMenuArray([...menu(t, navigate), ...cashierMenu(t, navigate)]);
    } else if ([3, 5, 6].includes(user?.role_id)) {
      setNavMenuArray(cashierMenu(t, navigate));
    } else {
      setNavMenuArray(menu(t, navigate));
    }
  }, [user?.role_id, i18n.language]);

  useEffect(() => {
    if (navMenuArray.length && !childrens) {
      let activeItem = navMenuArray.find((item) =>
        location.pathname.startsWith(item.path),
      );

      if (!activeItem) {
        activeItem = navMenuArray.find((item) =>
          item.children?.some((child) =>
            location.pathname.startsWith(child.path),
          ),
        );
      }

      if (activeItem?.children?.length > 0) {
        setChildrens(activeItem);
      }
    }
  }, [navMenuArray, location.pathname]);
  useEffect(() => {
    localStorage.setItem("sidebar-collapsed", collapsed);
  }, [collapsed]);
  const filteredMenu = navMenuArray.filter((item) =>
    item.label?.toLowerCase().includes(filterText.toLowerCase()),
  );
  useEffect(() => {
    const handleKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.code === "KeyK") {
        e.preventDefault();
        searchRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  const renderMenuItems = () => (
    <div className="flex flex-col">
      {/* SEARCH */}
      {!collapsed && (
        <div className="px-2 mb-3">
          <SearchField
            ref={searchRef}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            handleClearClick={() => setFilterText("")}
            placeholder={t("Search")}
          />
        </div>
      )}

      {/* MENU ITEMS */}
      {filteredMenu.map((item, i) => {
        const active = isActivePath(item, location);

        return (
          <div
            key={i}
            className={`cursor-pointer ${active ? "bg-[#1fb1ec]" : ""}`}
            title={collapsed ? item.label : ""}
          >
            <div
              className={`flex items-center gap-2 py-3 px-3 group ${
                collapsed ? "justify-center" : ""
              }`}
              onClick={() => {
                if (item?.children?.length > 0) setChildrens(item);
                navigate(item.path);
                setNavMenuOpen(false);
              }}
            >
              {/* ICON */}
              <div
                className={`flex h-[30px] w-[30px] items-center justify-center rounded-full border border-white
  transition-colors duration-200
  ${
    active
      ? "bg-white text-primary"
      : "text-white group-hover:bg-white group-hover:!text-primary"
  }`}
              >
                {item.icon(
                  active
                    ? "!text-primary"
                    : "text-white group-hover:!text-primary",
                )}
              </div>

              {/* LABEL */}
              {!collapsed && (
                <p className="text-[14px] text-white font-[400]">
                  {item.label}
                </p>
              )}
            </div>
          </div>
        );
      })}

      {/* COLLAPSE BUTTON */}
      <div className="mt-auto border-t border-white/10 p-2">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="w-full text-white hover:bg-white/10 rounded-md py-2"
        >
          <i
            className={`pi ${collapsed ? "pi-angle-right" : "pi-angle-left"} text-lg`}
          ></i>
        </button>
      </div>
    </div>
  );

  // Custom render for Mobile to match the requested design
  const renderMobileMenuItems = () => (
    <div className="flex flex-col">
      {/* SEARCH - Keeping functionality but potentially could be removed if strict design match required, but user said 'functionality mere wali hi rahe' */}
      {/* <div className="px-2 mb-3">
          <SearchField
            ref={searchRef}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            handleClearClick={() => setFilterText("")}
            placeholder={t("Search")}
          />
        </div> */}
      {filteredMenu.map((item, i) => {
        const active = isActivePath(item, location);
        return (
          <div
            key={i}
            className={`flex flex-row text-white gap-2 group items-center pe-1 ps-3 py-3 sidebar-navlink cursor-pointer ${active ? "bg-[#1fb1ec]" : ""}`}
            onClick={() => {
              if (item?.children?.length > 0) setChildrens(item);
              navigate(item.path);
              setNavMenuOpen(false);
            }}
          >
            <div
              className={`flex border border-white h-[25px] text-white justify-center rounded-full w-[25px] group-hover:bg-white group-hover:!text-primary items-center ${active ? "bg-white !text-primary" : ""}`}
            >
              {item.icon(
                active
                  ? "!text-primary"
                  : "text-white group-hover:!text-primary",
              )}
            </div>
            <p className="text-[14px] text-white font-[400] group-hover:text-white mt-1">
              {item.label}
            </p>
          </div>
        );
      })}
    </div>
  );

  const customHeader = (
    <div className="flex align-items-center gap-2">
      <img
        src="/images/supergit-03.png"
        alt="logo"
        className="h-[50px] w-[50px]"
      />
    </div>
  );

  return (
    <>
      {/* New Mobile Sidebar from User Request */}
      <Sidebar
        visible={navMenuOpen}
        header={customHeader}
        onHide={() => setNavMenuOpen(false)}
        pt={{
          root: { className: "w-[240px] rounded !bg-primary" },
          header: {
            className:
              "flex items-center justify-between border-b border-gray-800 !py-2",
          },
          content: { className: "px-0" },
          closebutton: { className: "!text-white" },
        }}
      >
        {renderMobileMenuItems()}
      </Sidebar>

      {/* DESKTOP SIDEBAR */}
      <div
        className={`bg-primary hidden md:block h-full overflow-y-auto pt-4 transition-all duration-300
        ${collapsed ? "w-[70px]" : "w-[190px]"}`}
      >
        {renderMenuItems()}
      </div>
    </>
  );
}

export default SideBar;
